export const blogPostsToSyncWithTransifex = [
    'pomodoro-technique',
    'getting-things-done',
    'weekly-review',
    'kanban',
    'time-blocking',
    'eisenhower-matrix',
    'eat-the-frog',
    'okrs-objectives-key-results',
]
export const supportedLanguages = ['en', 'de', 'fr', 'es', 'ja', 'nl', 'pt-BR', 'ru']
